import React, { useEffect, useState } from "react";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../components/CustomPagination";
import { handleFlgStatus } from "../../../components/facilities/TreasuryFacility";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig } from "../../customer/customer.config";

const { Text } = Typography;

const statusOptions = [
  { key: 1, value: "status", label: "All Status" },
  { key: 2, value: "active", label: "Active" },
  { key: 3, value: "approved", label: "Approved" },
  { key: 4, value: "pending", label: "Pending Approval" },
  { key: 5, value: "disbursed", label: "Disbursed" },
  { key: 6, value: "rejected", label: "Rejected" },
];

const breadcrumbItems = [{ title: "Loan Origination" }];

const ManageLoanOrigination = (props) => {
  const navigate = useNavigate();
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;

  const [applicationList, setApplicationList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("status");
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isSearch, setIsSearch] = React.useState(1);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();

  const filteredList =
    selectedStatus === "status"
      ? applicationList
      : applicationList.filter(
          (item) =>
            item?.status?.toLowerCase() === selectedStatus.toLowerCase(),
        );

  const columns = [
    {
      title: "Application Ref",
      dataIndex: "applicationRef",
      sorter: (a, b) => a.applicationRef.localeCompare(b.applicationRef),
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      sorter: (a, b) => a.customerName.localeCompare(b.customerName),
    },
    {
      title: "Loan Product",
      dataIndex: "loanProduct",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "right",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, record) => (
        <Text>{handleFlgStatus(record?.status, {}, true)}</Text>
      ),
    },
  ];

  useEffect(() => {
    rightAction(cnt.RIGHT_ADD_BTN);
  }, [selectedStatus]);

  const getListAction = (offset = 0, limit = Number(tableCount)) => {
    setCurrentPage(1);
    const params = {
      limit,
      offset,
      orderBy: "id",
      sortOrder: "DESC",
      ...(selectedStatus !== "status" && { status: selectedStatus }),
    };

    const body = { session, params };

    setIsLoading(true);
    setIsSearch(false);
    BOM.FetchReqAction(body, apiConfig.LoanAccounts, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);
        setTotalItems(res?.totalFilteredRecords || 0);
        const objList = res?.pageItems || [];
        const tempArray = objList.map((element) => {
          const statusValue = element?.status?.value || "-";
          return {
            key: element?.id,
            id: element?.id,
            applicationRef: element?.accountNo || "-",
            customerName: element?.clientName || "-",
            loanProduct: element?.loanProductName || "-",
            amount: element?.principal
              ? "₦" + Number(element.principal).toLocaleString("en-NG")
              : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
          };
        });
        setApplicationList(tempArray);
        setOriginalList(tempArray);
        setIsLoading(false);
      }
    });
  };

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN, cnt.RIGHT_EDIT_BTN].forEach((item) => {
      dispatch({ type: item });
    });
  };

  const selectTableCount = (value) => {
    setTableCount(value);
    onRefresh(0, value);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
    setCurrentPage(1);
  };

  const handleOnView = () => {
    const { detailBtn } = rightBtn;
    if (detailBtn?.toLowerCase() === "primary") {
      navigate("/detail-loan-origination", { state: selectedRow });
    }
  };

  const handleOnCreate = () => {
    const { addBtn } = rightBtn;
    if (addBtn?.toLowerCase() === "primary") {
      navigate("/new-loan-origination", { state: selectedRow });
    }
  };

  const handleOnEdit = () => {
    const { editBtn } = rightBtn;
    if (editBtn?.toLowerCase() === "primary") {
      navigate("/edit-loan-origination", { state: selectedRow });
    }
  };

  const onSearch = (formValue) => {
    setIsLoading(true);
    const params = {
      exactMatch: false,
      query: formValue.searchKey,
      resource: "loans",
    };
    const body = { session, params };
    setIsSearch(true);

    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        setIsLoading(false);
        const tempArray = objList.map((element) => {
          const statusValue = element?.entityStatus?.value || "-";
          return {
            key: element?.entityId,
            id: element?.entityId,
            applicationRef: element?.entityAccountNo || "-",
            customerName: element?.entityName || "-",
            loanProduct: "-",
            amount: "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
          };
        });
        setApplicationList(tempArray);
        setOriginalList(tempArray);
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    useForm.resetFields();
    getListAction(offset, limit);
    setCurrentPage(1);
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      pageItems={breadcrumbItems}
    >
      <TopContent
        pageTitle="Loan Origination"
        createPageTitle="Loan Applications"
      />

      <Card
        title={
          <>
            Loan Applications{" "}
            <Button
              type="primary"
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              onClick={() => onRefresh()}
              icon={<ReloadOutlined />}
              loading={isLoading}
            >
              Refresh
            </Button>
          </>
        }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <Row style={{ marginLeft: 10 }}>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form form={useForm} onFinish={onSearch}>
                  <Space.Compact style={{ width: "100%" }}>
                    <Form.Item
                      name="searchKey"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("This field "),
                        },
                      ]}
                    >
                      <Input
                        placeholder="Search by Application Ref / Customer Name"
                        style={{ width: 400 }}
                        allowClear
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      className="of-primaryBtnColor"
                      htmlType="submit"
                      style={{ borderRadius: "0px 5px 5px 0px" }}
                    >
                      <SearchOutlined />
                    </Button>
                    <div style={{ marginLeft: "20px" }}>
                      <div style={{ marginBottom: "auto", marginLeft: 10 }}>
                        <Select
                          value={selectedStatus}
                          options={statusOptions}
                          onChange={handleStatusChange}
                          placeholder="Select Status"
                          dropdownStyle={{ width: "250px" }}
                          className="interbank-table-select"
                        />
                      </div>
                    </div>
                  </Space.Compact>
                </Form>
              </Col>
            </Row>
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={filteredList}
            bordered
            pagination={false}
            scroll={{ x: 800 }}
          />
          {!isSearch && (
            <CustomPagination
              totalItems={totalItems}
              pageSize={Number(tableCount)}
              onPageChange={(page, offset) => onRefresh(offset)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageLoanOrigination);
